import React, { useEffect, useMemo, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "reactstrap"

import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import { useLazyGetDashboardWealthPartnersQuery } from "store/api/reports/reports"
import { formatAmount } from "helpers/common"
import NoData from "../../../assets/images/noData.svg"

const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]
const DashbordWealthPartners = () => {
  const [partners, setPartners] = useState([])
  const [getResults, { isFetching }] = useLazyGetDashboardWealthPartnersQuery()
  const [menu, setMenu] = useState(false)
  const [period, setPeriod] = useState("This Year")

  const getList = async () => {
    try {
      const { data } = await getResults({ period }).unwrap()
      setPartners(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [period])

  return (
    <React.Fragment>
      <div className="container-inner-right-box">
        <div className="filter-section">
          <h4>Wealth Partners Details</h4>
          <div className="dropdown-section">
            <Dropdown isOpen={menu} toggle={() => setMenu(!menu)}>
              <DropdownToggle size="lg">
                {period} <img src={downArrowIcon} alt="" />
              </DropdownToggle>
              <DropdownMenu
                style={{
                  minWidth: "auto",
                }}
              >
                {periods.map((item, index) => (
                  <DropdownItem
                    key={`periods_${index}`}
                    onClick={() => setPeriod(item)}
                  >
                    {item}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div className="investor-table-wrapper">
          <Table>
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#1667AD",
                    padding: "2px 10px",
                    minWidth: "150px",
                  }}
                  className="name text-start"
                >
                  Name
                </th>
                <th
                  style={{
                    backgroundColor: "#1C7ED2",
                  }}
                >
                  <div className="text-center">No. of Investors</div>
                </th>
                <th className="action text-center">Commission(₹)</th>
              </tr>
            </thead>
            <tbody>
              {partners.map((item, index) => (
                <tr key={`partners${index}`}>
                  <td className="text-start">{item.name}</td>
                  <td>
                    <div className="text-center">{item?.investorCount}</div>
                  </td>
                  <td>
                    <div className="text-center">
                      {formatAmount(item?.commission)}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {!isFetching && partners.length <= 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "250px",
              }}
            >
              <img
                src={NoData}
                style={{
                  maxWidth: "160px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {"No Records Found"}
              </h4>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default DashbordWealthPartners
